import * as Types from './types'

export default {
  SET_CUSTOMER: async ({ commit }, payload) => {
    commit(Types.SET_CUSTOMER, payload)
  },
  SET_SELECTED_CUSTOMER: async ({ commit }, payload) => {
    commit(Types.SET_SELECTED_CUSTOMER, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/buyer/actions.js